import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CspNonceService {
  private readonly nonce: string | null = null;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    const appRoot = this.document.querySelector('app-root');
    if (appRoot) {
      this.nonce = appRoot.getAttribute('ngCspNonce');
    }
  }

  getNonce(): string | null {
    return this.nonce;
  }
}